import Placeholder from "./placeholder";
export * from "./placeholderField";

export default Placeholder;
